<div class="card step-card flex flex-column">
  <form *ngIf="formLoaded && sequenceForm" [formGroup]="sequenceForm" class="fadein">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name-sequence">{{ 'attribute.name' | transloco }} (*)</label>
        </div>
        <div class="col-12">
          <input class="w-full" formControlName="name" id="name-sequence" pInputText type="text">
          <app-validation-errors [control]="sequenceForm.get('name')"></app-validation-errors>
        </div>

      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label [for]="'tenant-sequence'">{{ 'model.tenant' | transloco }} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            (onChange)="onTenantChange($event)"
            [filter]="true"
            [options]="tenants"
            [placeholder]="'select.tenant' | transloco"
            formControlName="tenant"
            inputId="tenant-sequence"
            optionLabel="name"
            styleClass="w-full"
          ></p-dropdown>
          <app-validation-errors [control]="sequenceForm.get('tenant')"></app-validation-errors>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label [for]="'organization-sequence'">{{ 'model.organization' | transloco }} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [filter]="true"
            [options]="organizations"
            [placeholder]="'select.organization' | transloco"
            formControlName="organization"
            inputId="organization-sequence"
            optionLabel="name"
            showClear="true"
            dataKey="uuid"
            styleClass="w-full"
          ></p-dropdown>
          <app-validation-errors [control]="sequenceForm.get('organization')"></app-validation-errors>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label [for]="'schedule-type-sequence'">{{ 'attribute.scheduleType' | transloco }} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            (onChange)="onScheduleTypeChange($event)"
            [options]="sequenceScheduleTypes"
            [placeholder]="'select.sequenceScheduleType' | transloco"
            formControlName="sequenceScheduleType"
            inputId="schedule-type-sequence"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full"
          >
            <ng-template let-item pTemplate="selectedItem">
              {{ item.label | transloco }}
            </ng-template>
            <ng-template let-item pTemplate>
              {{ item.label | transloco }}
            </ng-template>
          </p-dropdown>
          <app-validation-errors [control]="sequenceForm.get('sequenceScheduleType')"></app-validation-errors>
        </div>
      </div>
      <ng-container *ngIf="sequenceForm.get('sequenceScheduleType')?.value">
        <div class="col-12" *ngIf="sequenceForm.get('sequenceScheduleType')?.value != 'NONE'">
          <fieldset>
            <ng-container [ngSwitch]="sequenceForm.get('sequenceScheduleType')?.value">
              <ng-container *ngSwitchCase="'RECURRENT'">
                <legend class="block mb-2">
                  {{ "misc.sequence.scheduleType.recurrent" | transloco }}:
                </legend>
                <div class="col-12">
                  <div class="form-field col-12">
                    <label [for]="'recurrent-time-sequence'">{{ 'attribute.recurrentTimeExecution' | transloco }}
                      (*)</label>
                  </div>
                  <p-dropdown styleClass="w-full"
                              formControlName="recurrentTime"
                              id="recurrent-time-sequence"
                              optionLabel="key"
                              optionValue="value"
                              [options]="recurrentTimes">
                  </p-dropdown>
                  <app-validation-errors [control]="sequenceForm.get('recurrentTime')"></app-validation-errors>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'SCHEDULED'">
                <legend class="block mb-2">
                  {{ "misc.sequence.scheduleType.daily" | transloco }}:
                </legend>
                <div class="grid">
                  <div class="field sm:col-6 col-12">
                    <label [for]="'start-date-sequence'" class="w-full">
                      {{ "attribute.startDate" | transloco }} (*)
                    </label>
                    <p-calendar
                      #startDateCalendar
                      (onSelect)="validateDatesForm()"
                      [minDate]="currentDate"
                      class="w-full sm:w-15rem"
                      dateFormat="dd/mm/yy"
                      formControlName="startDate"
                      inputId="start-date-sequence"
                      readonlyInput="true"
                      styleClass="w-full"
                    ></p-calendar>
                    <app-validation-errors [control]="sequenceForm.get('startDate')"></app-validation-errors>
                  </div>
                  <div class="field sm:col-6 col-12">
                    <label [for]="'end-date-sequence'" class="w-full">
                      {{ "attribute.endDate" | transloco }} (*)
                    </label>
                    <p-calendar
                      (onSelect)="validateDatesForm()"
                      [minDate]="startDateCalendar?.value || currentDate"
                      class="w-full sm:w-15rem"
                      dateFormat="dd/mm/yy"
                      formControlName="endDate"
                      inputId="end-date-sequence"
                      readonlyInput="true"
                      required
                      styleClass="w-full"
                    ></p-calendar>
                    <app-validation-errors [control]="sequenceForm.get('endDate')"></app-validation-errors>
                  </div>
                  <div class="field sm:col-6 col-12">
                    <label [for]="'scheduled-time-sequence'" class="w-full">
                      {{ "attribute.scheduledTime" | transloco }} (*)
                    </label>
                    <p-calendar
                      [timeOnly]="true"
                      class="w-full sm:w-15rem"
                      formControlName="scheduledTime"
                      hourFormat="12"
                      inputId="scheduled-time-sequence"
                      readonlyInput="true"
                      required
                      styleClass="w-full"
                    ></p-calendar>
                    <app-validation-errors [control]="sequenceForm.get('scheduledTime')"></app-validation-errors>
                  </div>
                  <div class="field sm:col-6 col-12">
                    <fieldset>
                      <legend class="block mb-2" id="descriptionWeekly">
                        {{ "attribute.repeatWeekDays" | transloco }}:
                      </legend>
                      <div class="flex flex-row flex-wrap justify-content-between sm:justify-content-start gap-3">
                        <div class="p-field-checkbox flex align-items-center gap-1">
                          <p-checkbox
                            binary="true"
                            formControlName="monday"
                            inputId="monday"
                          ></p-checkbox>
                          <label [for]="'monday'">{{ "attribute.week.monday" | transloco }}</label>
                        </div>
                        <div class="p-field-checkbox flex align-items-center gap-1">
                          <p-checkbox
                            binary="true"
                            formControlName="tuesday"
                            inputId="tuesday"
                          ></p-checkbox>
                          <label [for]="'tuesday'">{{ "attribute.week.tuesday" | transloco }}</label>
                        </div>
                        <div class="p-field-checkbox flex align-items-center gap-1 ">
                          <p-checkbox
                            binary="true"
                            formControlName="wednesday"
                            inputId="wednesday"
                          ></p-checkbox>
                          <label [for]="'wednesday'">{{ "attribute.week.wednesday" | transloco }}</label>
                        </div>
                        <div class="p-field-checkbox flex align-items-center gap-1">
                          <p-checkbox
                            binary="true"
                            formControlName="thursday"
                            inputId="thursday"
                          ></p-checkbox>
                          <label [for]="'thursday'">{{ "attribute.week.thursday" | transloco }}</label>
                        </div>
                        <div class="p-field-checkbox flex align-items-center gap-1">
                          <p-checkbox
                            binary="true"
                            formControlName="friday"
                            inputId="friday"
                          ></p-checkbox>
                          <label [for]="'friday'">{{ "attribute.week.friday" | transloco }}</label>
                        </div>
                        <div class="p-field-checkbox flex align-items-center gap-1">
                          <p-checkbox
                            binary="true"
                            formControlName="saturday"
                            inputId="saturday"
                          ></p-checkbox>
                          <label [for]="'saturday'">{{ "attribute.week.saturday" | transloco }}</label>
                        </div>
                        <div class="p-field-checkbox flex align-items-center gap-1">
                          <p-checkbox
                            binary="true"
                            formControlName="sunday"
                            inputId="sunday"
                          ></p-checkbox>
                          <label [for]="'sunday'">{{ "attribute.week.sunday" | transloco }}</label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </fieldset>
        </div>
      </ng-container>
    </div>
  </form>
  <ng-container *ngIf="!formLoaded">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name-sequence">{{ 'attribute.name' | transloco }} (*)</label>
        </div>
        <div class="col-12">
          <p-skeleton height="30.8px"></p-skeleton>
        </div>

      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label [for]="'tenant-sequence'">{{ 'model.tenant' | transloco }} (*)</label>
        </div>
        <div class="col-12">
          <p-skeleton height="30.8px"></p-skeleton>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label [for]="'organization-sequence'">{{ 'model.organization' | transloco }} </label>
        </div>
        <div class="col-12">
          <p-skeleton height="30.8px"></p-skeleton>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label [for]="'schedule-type-sequence'">{{ 'attribute.scheduleType' | transloco }} (*)</label>
        </div>
        <div class="col-12">
          <p-skeleton height="30.8px"></p-skeleton>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          (click)="onNextStep()"
          [disabled]="isValid()"
          [label]="'common.next'| transloco"
          class="p-button-primary sm:ml-2 ml-0 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
          pButton
          pRipple
        ></button>
      </div>
      <button
        (click)="cancel()"
        [label]="'common.cancel' | transloco"
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
        pButton
        pRipple
      ></button>
    </div>
  </div>
</div>
